<template>
	<BaseCmsPage>
		<BaseThemeWebshopPageContent />
		<BaseTrackingRefund />
	</BaseCmsPage>
</template>
